import { SVGProps } from 'react';

export const InfoOutlineIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg data-icon width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="8" cy="8" r="6.4" stroke="currentColor" strokeWidth="1.2" />
    <path d="M8 7v4" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="8" cy="5" r="0.75" fill="currentColor" />
  </svg>
);
